import styled from "styled-components";

import { EntityKind } from "models/entityKind";

import { GroupByProvider } from "components/groupBy/group-by.context";
import { WellCard, WellDetailsStoreProvider } from "components/vis";

/**
 * The Well Ticket ships whole, with its own fetch, its own sub-tabs and its own
 * categories. It is pinned to the panel's target so it cannot describe a second
 * well while the map selection sits somewhere else, and its own UWI heading is
 * dropped because the panel header above already carries it.
 */
export function DetailsTab({ uwi }: { uwi: Maybe<string> }): JSX.Element {
  return (
    <Wrapper>
      <TicketArea>
        <GroupByProvider>
          <WellDetailsStoreProvider>
            <WellCard
              entityKind={EntityKind.Well}
              uwi={uwi}
              hideEntityName
              alignHeaderValuesRight
            />
          </WellDetailsStoreProvider>
        </GroupByProvider>
      </TicketArea>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  padding: 8px 14px 16px;
`;

const TicketArea = styled.div`
  flex: 1;
  min-height: 400px;
`;
